import { get, identity, pickBy } from 'lodash';
const throwRequired = (name) => {
    throw new Error(`${name} is required`);
};
export const parseSiteFont = (fontObj, { onlyFamily }) => {
    let font = fontObj.value;
    if (onlyFamily) {
        const fontFamily = fontObj.family || fontObj.fontFamily || '';
        let fontFamilyIdx = -1;
        if (fontFamily.includes(' ')) {
            fontFamilyIdx = fontObj.value.indexOf(`"${fontFamily}"`);
        }
        if (fontFamilyIdx === -1) {
            fontFamilyIdx = fontObj.value.indexOf(fontFamily);
        }
        font = fontObj.value.substring(fontFamilyIdx);
    }
    if (font.slice(0, 5) === 'font:') {
        font = font.slice(5);
    }
    return font.replace(/[;]+$/g, '');
};
export const getSiteFont = (appSettings, { wixParam, presetFallback, fontFallback, onlyFamily }) => {
    if (!wixParam) {
        throwRequired('wixParam');
    }
    if (!presetFallback) {
        throwRequired('presetFallback');
    }
    if (!fontFallback) {
        throwRequired('fontFallback');
    }
    const font = get(appSettings, `style.fonts.${wixParam}`) ||
        get(appSettings, `textPresets.${presetFallback}`) || {
        value: fontFallback,
    };
    return parseSiteFont(font, { onlyFamily });
};
/** Extract font properties from the `font` CSS attribute.
 * Regex takes a `font` string, for all its possibilities, and parses it to an object according to CSS specification.
 * https://www.w3.org/TR/CSS21/fonts.html#font-shorthand
 *
 * @example
 * `font: normal normal normal 40px/1.4em "open sans", sans-serif;`
 */
export const extractFontObjAttrs = (fontObject) => {
    const siteFont = parseSiteFont(fontObject, {});
    const regex = /^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:%|in|[cem]m|ex|p[ctx])))?\s*(\S.+?\S)\s*$/i;
    const parts = regex.exec(siteFont);
    if (!parts) {
        return {};
    }
    const [, fontStyle, fontVariant, fontWeight, fontSize, lineHeight, fontFamily,] = parts;
    return pickBy({
        fontStyle,
        fontVariant,
        fontWeight,
        fontSize,
        lineHeight,
        fontFamily,
    }, identity);
};
//# sourceMappingURL=fonts.js.map